import * as paper from 'paper';
import {Point} from "paper";
import {DrawData} from "../drawData";
import {DisplayFunctions} from "./displayFunctions";

export class SinkItem {
    static selectedSink: any = null;
    static didMoveSink = false;

    static setSelectedSink(selectedSink: any) {
        SinkItem.selectedSink = selectedSink;
        SinkItem.didMoveSink = false;
    }

    static movingSink(delta: any, drawDataObj: DrawData) {
        if (SinkItem.selectedSink == null) {
            return;
        }
        SinkItem.selectedSink.bringToFront();
        SinkItem.didMoveSink = true;
        var sinkPosition = new Point(SinkItem.selectedSink.position);

        sinkPosition.x += delta.x;
        sinkPosition.y += delta.y;
        //04/17/2017-Liem Bui [Sage-655] Fridge & Range & Dish Washer
        if (SinkItem.selectedSink.data.typeID.typeEnum == 4
            || SinkItem.selectedSink.data.typeID.typeEnum == 5) {
            SinkItem.selectedSink.position = sinkPosition;
        } else if (drawDataObj.sinkRemainsOnCounter(SinkItem.selectedSink.data.path, sinkPosition, SinkItem.selectedSink.data.typeID.typeEnum)) {
            SinkItem.selectedSink.position = sinkPosition;
        }
    }

    static hasEnumType(typeEnum: number): boolean {
        return SinkItem.selectedSink &&
            SinkItem.selectedSink.data &&
            SinkItem.selectedSink.data.typeID &&
            SinkItem.selectedSink.data.typeID.typeEnum == typeEnum;
    }

    static hasNotEnumType(typeEnum: number): boolean {
        return SinkItem.selectedSink &&
            SinkItem.selectedSink.data &&
            SinkItem.selectedSink.data.typeID &&
            SinkItem.selectedSink.data.typeID.typeEnum != typeEnum;
    }

    static resizeSink(sinkRaster: any, xDelta: any, yDelta: any) {
        sinkRaster.rotate(-1 * sinkRaster.data.angle);
        var height = sinkRaster.bounds.height, width = sinkRaster.bounds.width;
        var scaleRatioH = 1.0 + (yDelta / height);
        var scaleRatioW = 1.0 + (xDelta / width);

        height *= scaleRatioH;
        width *= scaleRatioW;
        if ((height > DisplayFunctions.PIXEL_INCH_RATE / 2) && (width > DisplayFunctions.PIXEL_INCH_RATE / 2)) {
            sinkRaster.scale(scaleRatioW, scaleRatioH);
        }

        sinkRaster.rotate(sinkRaster.data.angle);
    }

}
